// extracted by mini-css-extract-plugin
export default {"page-loader":"PageLoader_page-loader__V8x0I"};